import Zoom from "@arcgis/core/widgets/Zoom";
import MapView from "@arcgis/core/views/MapView";
import { consoleSuccessStyle } from "../../../shared/constants/logging.constants";

export class ZoomService {
  private static instance: ZoomService;
  private zoomWidget!: Zoom;
  private mapView: MapView;

  private constructor(mapView: MapView) {
    this.mapView = mapView;
    this.buildZoomWidget();
  }

  private buildZoomWidget(): void {
    this.zoomWidget = new Zoom({
      view: this.mapView,
      container: "zoomContainer",
    });

    this.mapView.ui.add(this.zoomWidget, {
      position: "top-left",
      index: 300,
    });

    // eslint-disable-next-line no-console
    console.info("%cZoom Widget Initialized", consoleSuccessStyle);
  }

  public static getInstance(mapView: MapView): ZoomService {
    if (!ZoomService.instance) {
      ZoomService.instance = new ZoomService(mapView);
    }
    return ZoomService.instance;
  }

  public getZoomWidget(): Zoom {
    return this.zoomWidget;
  }
}
